import * as React from "react";
import * as moment from "moment";
import {Renewal, resourcesHelper, PREMIUM_TYPE_ANNUAL} from "@falcon/services";


interface IProps {
    renewalProposal?: Renewal;
    product: string;
    productContent: JSX.Element;
    monthlyInstalmentsAllowed: boolean;
}

// Banner in header to inform that policy will be renewed
export class PolicyWillBeRenewedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const pendingRenewalDate: moment.Moment = moment.utc(this.props.renewalProposal?.headerInfo.startDate, moment.ISO_8601);
        return (
            <div className="banner pending-renewal-banner">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <p>
                        Rest easy - your {this.props.product} insurance policy for{' '}
                        <strong>{this.props.productContent} is scheduled to renew on {pendingRenewalDate.format("D MMMM YYYY, 00:00")}.</strong>{' '}
                        No payment will be taken until then.
                    </p>
                    {this.props.renewalProposal?.factors.premiumType === PREMIUM_TYPE_ANNUAL && this.props.monthlyInstalmentsAllowed && <p>Monthly instalments are available at additional cost.</p>}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/banners/PolicyWillBeRenewedBanner.tsx